import { AllotmentNode, Carac, ProjectSheet, Sheet, SheetIndex, SheetOptions, Unit, User } from "../../../types/noocoDbTypes";
import { CaracCombo } from "../../../types/noocoTypes";
import * as general from "../../general";

export type PostBundleBody = {
    quantity: number,
    comment: string,
    caracteristic: {
        equipmentName: string,
        labelQuote: string,
        lifeSpan: number,
        unit: string
    },
    isCarbonWeightSelected: boolean,
    customACV: {
        AProd: number | null,
        AEdif: number | null,
        B: number | null,
        C: number | null,
        D: number | null
    },
    materialComposition: {
        manufacturedRate: number,
        totalWeight: number,
        materialLines: {
        allotmentNode: AllotmentNode,
        percent: number
        }[]
    },
    type: string,
    folderSheetId: number | null,
    typeOfSheet: string
};

interface ProjectSheetWithCaracData extends ProjectSheet {

    AllotmentNodes: AllotmentNode[],
    Caracs: Carac[],
    caracCombos: CaracCombo[],
    Sheet: {
        security_coefficient: number | null,
        source: string | null,
    }

};

export interface MovingFolderBody {
    id: number,
    folderSheetId: number,
    CompanyId: number,
    moveFolder: boolean,
};

export interface SheetWithPreviousBundleId {
    id: number,
    bundle: BundleSheet | ProductModeledSheet,
};
export interface ReturnIfNoCommentButMoved extends ReturnIfCommentOnlyUpdated {
    comment: string,
};
export interface ReturnIfCommentOnlyUpdated {
    id: number,
    hasBeenMoved : boolean,
};
export interface BundleSheet extends Sheet {
    ProjectSheets: ProjectSheetWithCaracData[],
    Unit: Unit,
    User: User,   
    Emissions: number, 
    editComment: boolean,
};

export interface ProductModeledSheet extends Sheet {
    SheetOptions: SheetOptions[],
    SheetIndex: SheetIndex[],
    User: User,
};

export interface BundlePostRequest {
    Body: PostBundleBody;
}

export interface BundlePatchRequest {
    Body: PostBundleBody;
}

export const bundleBadRequestReturnMessage = "Missing parameters";


export function postBundleSuccess(createdSheet: BundleSheet | ProductModeledSheet): general.SuccessReturnBody {
    return general.getSuccessReturnBody(createdSheet);
  }

export function postBundleBadRequest(): general.BadRequestReturnBody {
    return general.getBadRequestReturnBody(bundleBadRequestReturnMessage);
  }

export function postBundleServerError(): general.ServerErrorReturnBody {
    return general.getServerErrorReturnBody();
  }

export function patchBundleSuccess(updatedSheet: SheetWithPreviousBundleId): general.SuccessReturnBody {
    return general.getSuccessReturnBody(updatedSheet);
  }
  export function patchBundleCommentOnlySuccess(updatedComment: ReturnIfCommentOnlyUpdated | ReturnIfNoCommentButMoved): 
    general.SuccessReturnBody {
        return general.getSuccessReturnBody(updatedComment);
}

export function patchBundleBadRequest(): general.BadRequestReturnBody {
    return general.getBadRequestReturnBody(bundleBadRequestReturnMessage);
  }
export function patchBundleServerError(): general.ServerErrorReturnBody {
    return general.getServerErrorReturnBody();
  }
